import {Directive, inject, input, TemplateRef} from '@angular/core';

/**
 *  Direktiv som lar deg bruke ng-template med typet kontekst
 *
 * Bruk:
 *  - i komponentens html:
 *  `<ng-template #templateNavn typetNgTemplate="templateKontekstType" let-etArgument="etArgument">...</ng-template>`
 *
 *  - i komponentens ts:
 *  `templateKontekstType!: {etArgument: string}`
 */
@Directive({
    selector: 'ng-template[typetNgTemplate]',
    standalone: true
})
export class TypetNgTemplateDirektiv<TypeToken> {

    // how you tell the directive what the type should be
    readonly typeToken = input.required<TypeToken>({alias: 'typetNgTemplate'});

    // the directive gets the template from Angular
    private readonly contentTemplate = inject(TemplateRef<TypeToken>);

    // this magic is how we tell Angular the context type for this directive, which then propagates down to the type of the template
    static ngTemplateContextGuard<TypeToken>(dir: TypetNgTemplateDirektiv<TypeToken>, ctx: unknown): ctx is TypeToken {
        return true;
    }
}
